import { withTranslation, WithTranslation } from 'react-i18next';
import React from 'react';
import {
  OneWayFeeModel,
  OneWayFeePriceItem,
  OneWayFeeRequest,
  OneWayFeeSupplierReferenceItem
} from '../../api/pricing/pricing.types';
import { DeskModel } from '../../api/core/core.types';
import { PricingApi } from '../../api/api.apiclient';
import { SupplierModel } from '../../api/admin/admin.types';
import { Link } from 'react-router-dom';
import ListViewTable from './ListViewTable';
import { PageRequest } from '../../api/api.types';

interface OneWayFeeTableProps extends WithTranslation {
  oneWayFees: OneWayFeeModel[];
  pickupDesks: DeskModel[];
  returnDesks: DeskModel[];
  waitingForResponse: (status: boolean) => void;
  canEdit: boolean;
  getOneWayFees: () => void;
  supplierInfo?: SupplierModel | null;
}

interface OneWayFeeTableState {
  changedPriceValue?: OneWayFeePriceItem;
  changedSupRefValue?: OneWayFeeSupplierReferenceItem;
  priceChanged: boolean;
  oneWayFees: OneWayFeeModel[];
  selectedPageNumber: number;
  sortOrder: 'ASC' | 'DESC';
  sortedBy: string;
  totalPages: number;
  totalElements: number;
  slicedOneWayFees: OneWayFeeModel[];
}

const OneWayFeeSortFields = [
  { value: 'pickupDeskCode', label: 'pickupDeskCode' },
  { value: 'returnDeskCode', label: 'returnDeskCode' }
];

const PAGE_SIZE = 100;

class OneWayFeeTable extends React.Component<OneWayFeeTableProps, OneWayFeeTableState> {
  constructor(props: OneWayFeeTableProps) {
    super(props);
    this.state = {
      changedPriceValue: undefined,
      changedSupRefValue: undefined,
      priceChanged: false,
      totalElements: 0,
      totalPages: 0,
      selectedPageNumber: 1,
      sortOrder: 'ASC',
      sortedBy: OneWayFeeSortFields[ 0 ].label,
      oneWayFees: [] as OneWayFeeModel[],
      slicedOneWayFees: [] as OneWayFeeModel[]
    };
    this.priceInputRef = React.createRef();
    this.supRefInputRef = React.createRef();
  }

  priceInputRef?: any;

  supRefInputRef?: any;

  componentDidMount() {
    if (this.props.oneWayFees && this.props.oneWayFees.length > 0) {
      this.getOneWayFees();
    }
  }

  componentDidUpdate(prevProps: Readonly<OneWayFeeTableProps>, prevState: Readonly<OneWayFeeTableState>, snapshot?: any) {
    if (this.props.oneWayFees !== prevProps.oneWayFees || prevProps.pickupDesks !== this.props.pickupDesks || prevProps.returnDesks !== this.props.returnDesks) {
      this.getOneWayFees();
    }
  }


  priceCell = (props: any) => {
    const { t } = this.props;
    return (
      <div className="w-100 h-100"
           onClick={(e) => e.stopPropagation()}>
        {(!this.state.changedPriceValue ||
          this.state.changedPriceValue.id !== props.row.original.pickupDeskCode + props.row.original.returnDeskCode) ? (
            <div className="editable-cell"
                 onClick={(e) => {
                   if (this.props.canEdit) {
                     e.stopPropagation();
                     this.addPriceItemWithIdAndValue(
                       props.row.original.pickupDeskCode + props.row.original.returnDeskCode,
                       props.row.original,
                       props.getValue()
                     );
                   }
                 }}>{props.getValue() !== null && props.getValue() !== undefined ? `${props.getValue()} ${this.props.supplierInfo?.baseCurrencyCode}` : t('v.owf.not_allowed')}
            </div>
          )
          :
          <div className={'editable-cell-change-input d-flex w-100 editable-cell'}>
            <input value={this.state.changedPriceValue.value} type={'number'}
                   min={0}
                   ref={(r) => this.setPriceInputRef(r)}
                   onKeyDown={(k) => this.handleKeyPressPriceValue(k)}
                   className={'confirm-input'}
                   placeholder={'enter value ...'}
                   onChange={(e) => this.handlePriceCellValueChange(e, props)}
                   onBlur={(e) => {
                     this.handlePriceInputFocusOut(
                       e.relatedTarget,
                       props.row.original.pickupDeskCode + props.row.original.returnDeskCode
                     );
                   }}
            />
            <button className={'cancel-option'}
                    onClick={(e) => {
                      this.removePriceItemWithIdFromState(this.state.changedPriceValue!.initialValue);
                    }}
                    id={`rank-cancel-${props.row.original.pickupDeskCode + props.row.original.returnDeskCode}`}>
            </button>
          </div>}
      </div>);
  };

  supRefCell = (props: any) => {
    return (
      <div className="w-100 h-100"
           onClick={(e) => e.stopPropagation()}>
        {!this.state.changedSupRefValue ||
        this.state.changedSupRefValue.id !== props.row.original.pickupDeskCode + props.row.original.returnDeskCode ?
          (
            <div className="editable-cell"
                 onClick={(e) => {
                   if (this.props.canEdit && props.row.original.price !== null && props.row.original.price !== undefined) {
                     e.stopPropagation();
                     this.addSupplierReferenceItemWithIdAndValue(
                       props.row.original.pickupDeskCode + props.row.original.returnDeskCode,
                       props.row.original,
                       props.getValue()
                     );
                   }
                 }}>{props.getValue()}
            </div>
          )
          :
          <div className={'editable-cell-change-input d-flex w-100 editable-cell'}>
            <input
              value={this.state.changedSupRefValue.value} type={'text'}
              min={0}
              ref={(r) => this.setSupRefInputRef(r)}
              onKeyDown={(k) => this.handleKeyPressSupRefValue(k)}
              className={'confirm-input'}
              placeholder={'enter value ...'}
              onChange={(e) => this.handleSupRefCellValueChange(e, props)}
              onBlur={(e) => {
                this.handleSupRefInputFocusOut(
                  e.relatedTarget,
                  props.row.original.pickupDeskCode + props.row.original.returnDeskCode
                );
              }}
            />
            <button className={'cancel-option'}
                    onClick={(e) => {
                      this.removeSupRefItemWithIdFromState(this.state.changedSupRefValue!.initialValue);
                    }}
                    id={`rank-cancel-${props.row.original.pickupDeskCode + props.row.original.returnDeskCode}`}>
            </button>
          </div>}
      </div>);
  };

  setPriceInputRef = (r: any) => {
    if (r) {
      this.priceInputRef = r;
    }
  };

  setSupRefInputRef = (r: any) => {
    if (r) {
      this.supRefInputRef = r;
    }
  };

  handlePriceInputFocusOut = (target: any, id: string) => {
    if (target && target.id && target.id === `rank-cancel-${id}`) {
      return;
    }
    const value = this.state.changedPriceValue!.value;
    this.removePriceItemWithIdFromState(value);
  };

  handleSupRefInputFocusOut = (target: any, id: string) => {
    if (target && target.id && target.id === `rank-cancel-${id}`) {
      return;
    }
    const value = this.state.changedSupRefValue!.value;
    this.removeSupRefItemWithIdFromState(value);
  };

  handleKeyPressPriceValue = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const value = this.state.changedPriceValue!.value;
      this.removePriceItemWithIdFromState(value);
    }

    if (e.key === 'Escape') {
      this.removePriceItemWithIdFromState(this.state.changedPriceValue!.initialValue);
    }
  };

  handleKeyPressSupRefValue = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const value = this.state.changedSupRefValue!.value;
      this.removeSupRefItemWithIdFromState(value);
    }

    if (e.key === 'Escape') {
      this.removeSupRefItemWithIdFromState(this.state.changedSupRefValue!.initialValue);
    }
  };

  callWaitingForResponse(status: boolean) {
    if (this.props.waitingForResponse) {
      this.props?.waitingForResponse(true);
    }
  }

  removePriceItemWithIdFromState = (value?: number) => {
    this.setState((s) => {
      const item = s.changedPriceValue!;

      const request: OneWayFeeRequest = item!.rowItem;
      request.price = value;
      if (value !== item.initialValue) {
        this.callWaitingForResponse(true);
        PricingApi.OneWayFees.editOneWayFee(request)
          .then(r => {
            this.props.getOneWayFees();
          });
      }

      return {
        ...s,
        changedPriceValue: undefined
      };
    });
  };

  removeSupRefItemWithIdFromState = (value?: string) => {
    this.setState((s) => {
      const item = s.changedSupRefValue!;

      const request: OneWayFeeRequest = item!.rowItem;
      request.supplierReferenceCode = value;
      if (value !== item.initialValue) {
        this.callWaitingForResponse(true);
        PricingApi.OneWayFees.editOneWayFee(request)
          .then(r => this.props.getOneWayFees());
      }

      return {
        ...s,
        changedSupRefValue: undefined
      };
    });
  };

  addPriceItemWithIdAndValue = (id: string, obj: OneWayFeeRequest, value?: number) => {
    this.setState({
        changedPriceValue: {
          id: id,
          value: value,
          initialValue: value,
          rowItem: obj
        }
      }
      , () => {
        if (this.priceInputRef) {
          this.priceInputRef.focus();
        }
      });
  };

  addSupplierReferenceItemWithIdAndValue = (id: string, obj: OneWayFeeRequest, value?: string) => {
    this.setState({
      changedSupRefValue: {
        id: id,
        value: value,
        initialValue: value,
        rowItem: obj
      }
    }, () => {
      if (this.supRefInputRef) {
        this.supRefInputRef.focus();
      }
    });
  };

  handlePriceCellValueChange = (e: any, props: any) => {
    const targetVal = e.target.value ? Number(e.target.value) : undefined;
    const request: OneWayFeeRequest = props.row.original;
    request.price = targetVal != null ? targetVal : undefined;

    if (!this.state.changedPriceValue) {
      this.addPriceItemWithIdAndValue(props.row.original.pickupDeskCode + props.row.original.returnDeskCode, request, targetVal);
    } else {
      this.setState((s) => {
        return {
          ...s,
          changedPriceValue: {
            ...s.changedPriceValue as OneWayFeePriceItem,
            value: targetVal
          }
        };
      });
    }
  };

  handleSupRefCellValueChange = (e: any, props: any) => {
    const targetVal = e.target.value ? String(e.target.value) : undefined;
    const request: OneWayFeeRequest = props.row.original;
    request.supplierReferenceCode = targetVal != null ? targetVal : undefined;

    if (!this.state.changedSupRefValue) {
      this.addSupplierReferenceItemWithIdAndValue(props.row.original.pickupDeskCode + props.row.original.returnDeskCode, request, targetVal);
    } else {
      this.setState((s) => {
        return {
          ...s,
          changedSupRefValue: {
            ...s.changedSupRefValue as OneWayFeeSupplierReferenceItem,
            value: targetVal
          }
        };
      });
    }
  };

  getOneWayFees() {
    const oneWayFees: OneWayFeeModel[] = [];
    this.props.pickupDesks.forEach((pud) => {
      this.props.returnDesks.forEach((dod) => {
        const oneWayFee = this.props.oneWayFees.find((owf) => {
          return owf.pickupDeskCode === pud.code && owf.returnDeskCode === dod.code;
        });
        if (oneWayFee) {
          oneWayFee.id = oneWayFee.pickupDeskCode + oneWayFee.returnDeskCode;
          oneWayFees.push(oneWayFee);
        } else {
          oneWayFees.push({
            id: pud.code + dod.code,
            supplierCode: '',
            pickupDeskCode: pud.code,
            returnDeskCode: dod.code,
            price: null,
            supplierReferenceCode: ''

          });
        }

        this.setState(
          {
            oneWayFees: oneWayFees,
            totalPages: Math.ceil(oneWayFees.length / PAGE_SIZE),
            totalElements: oneWayFees.length,
            slicedOneWayFees: oneWayFees.sort((a, b) => this.sortFunction(a, b, 'pickupDeskCode', 'ASC')).slice(0, PAGE_SIZE)
          });
      });

    });
  }

  sortFunction = (a: OneWayFeeModel, b: OneWayFeeModel, sortColumn: string, sortDirection: 'ASC' | 'DESC') => {
    const sortFieldName = OneWayFeeSortFields.find((column) => column.value === sortColumn);
    if (!sortFieldName) {
      return 0;
    }
    if (sortDirection === 'ASC') {
      switch (sortFieldName.value) {
        case 'pickupDeskCode':
          return a.pickupDeskCode.localeCompare(b.pickupDeskCode);
        case 'returnDeskCode':
          return a.returnDeskCode.localeCompare(b.returnDeskCode);
        default:
          return 0;
      }
    } else {
      switch (sortFieldName.value) {
        case 'pickupDeskCode':
          return b.pickupDeskCode.localeCompare(a.pickupDeskCode);
        case 'returnDeskCode':
          return b.returnDeskCode.localeCompare(a.returnDeskCode);
        default:
          return 0;
      }
    }
  };

  sortBy = (columnName: string, sortDirection: 'ASC' | 'DESC') => {
    const sortFieldName = OneWayFeeSortFields.find((column) => column.value === columnName);
    if (!sortFieldName) {
      return;
    }
    this.setState(
      {
        sortOrder: sortDirection,
        sortedBy: sortFieldName.label,
        slicedOneWayFees: this.state.oneWayFees.sort((a, b) => this.sortFunction(a, b, columnName, sortDirection)).slice(0, PAGE_SIZE)
      }
    );
  };

  getDataFn(pageRequest: PageRequest) {
    if (pageRequest.page !== undefined && pageRequest.sortField !== undefined && pageRequest.sortDirection !== undefined) {
      const begin = (pageRequest.page) * PAGE_SIZE;
      const end = begin + PAGE_SIZE;
      const sortDirection = pageRequest.sortDirection ?? 'ASC';
      const sortField = pageRequest.sortField ?? 'pickupDeskCode';
      const columnName = sortField;
      this.setState({
        selectedPageNumber: pageRequest.page + 1,
        sortOrder: sortDirection,
        sortedBy: OneWayFeeSortFields.find((column) => column.label === sortField)?.label ?? 'pickupDeskCode',
        slicedOneWayFees: this.state.oneWayFees.sort((a, b) => this.sortFunction(a, b, columnName, sortDirection)).slice(begin, end)
      });
    }
  }

  deskCell = (props: any) => {
    const puDesk = this.props.pickupDesks.find((d) => d.code === props.getValue());
    if (puDesk) {
      return <div>{puDesk.name} ({puDesk.code})</div>;
    } else {
      const desk = this.props.returnDesks.find((d) => d.code === props.getValue());
      if (desk) {
        return <div>{desk.name} ({desk.code})</div>;
      }
    }

    return <div>{props.getValue()}</div>;
  };


  defineColumns() {
    const { t } = this.props;
    return [
      {
        header: t('ct.one_way_fees.from'),
        accessorKey: 'pickupDeskCode',
        cell: this.deskCell,
        id: 'pickupDeskCode'
      },
      {
        header: t('ct.one_way_fees.to'), accessorKey: 'returnDeskCode', cell: this.deskCell, id: 'returnDeskCode'
      },
      { header: t('ct.one_way_fees.price'), accessorKey: 'price', cell: this.priceCell },
      {
        header: t('ct.one_way_fees.supplier_code'), accessorKey: 'supplierReferenceCode', cell: this.supRefCell
      },
      {
        header: 'Audit log', cell: (props: any) => {
          return <Link
            to={`/rates/onewayfees/audit?pickup=${props.row.original.pickupDeskCode}&return=${props.row.original.returnDeskCode}`}
            className="btn btn-text-only"
            target="_blank"
            rel="noopener noreferrer">
            {t('b.car_model.view_audit_log')}
          </Link>;
        }
      }
    ];
  }

  render() {
    const { t } = this.props;

    return (
      <div className={`table-list fees-table ${!this.props.canEdit ? 'disabled' : ''}`}>
        <ListViewTable
          data={this.state.slicedOneWayFees}
          columns={this.defineColumns()}
          sortBy={this.sortBy}
          sortOrder={this.state.sortOrder}
          sortedBy={OneWayFeeSortFields.find(({ value, label }) => this.state.sortedBy === label)?.value}
          paginationEnabled={true}
          totalPages={this.state.totalPages}
          totalElements={this.state.totalElements}
          selectedPageNumber={this.state.selectedPageNumber}
          getDataFn={(pageRequest: PageRequest) => this.getDataFn(pageRequest)}
        />
      </div>
    );
  }


}

export default withTranslation()(OneWayFeeTable);
